import React from 'react';

const SubmitIcon = ({ size = '24', fill = '#393536' }) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.50002 19.2499V4.75L20.7114 11.9999L3.50002 19.2499ZM4.63462 17.4922L17.7634 11.9999L4.63462 6.4519V10.6519L10.098 11.9999L4.63462 13.3076V17.4922Z"
          fill={fill}
        ></path>
      </svg>
    </>
  );
};

export default SubmitIcon;
